import type { Entry } from "./db";

// Türkçe Excel ondalık ayırıcı olarak virgül kullanır; bu yüzden sütunlar noktalı virgülle ayrılır
const SEP = ";";

const cell = (v: string) => (/[";\n\r]/.test(v) ? `"${v.replace(/"/g, '""')}"` : v);

export function downloadCsv(filename: string, entries: Entry[]) {
  const rows = [
    ["Tarih", "Müşteri", "Başlık", "Açıklama"],
    ...entries.map(e => [e.date, e.client_name, e.title, e.description]),
  ];
  const text = rows.map(r => r.map(cell).join(SEP)).join("\r\n");
  // BOM: Excel'in dosyayı UTF-8 olarak açıp Türkçe karakterleri bozmaması için
  const blob = new Blob(["﻿", text], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
